import React from "react";
import Nav from "./Nav";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const ResponsiveMenu = ({
    show,
    onClose,
    showSearch,
    onSearch,
}) => {
    const { t } = useTranslation();
    const elements = document.querySelectorAll(
        ".popup-mobile-menu .has-droupdown > a"
    );
    const elementsTwo = document.querySelectorAll(
        ".popup-mobile-menu .with-megamenu > a"
    );
    const links = document.querySelectorAll(".has-droupdown .submenu li a");
    const menus = document.querySelectorAll(".popup-mobile-menu");

    links.forEach(function (element) {
        element.onclick = function () {
            menus.forEach((menu) => {
                menu.classList.remove("active");
            });
        };
    });
    elements.forEach(function (element) {
        element.onclick = function () {
            this.parentElement.querySelector(".submenu").classList.toggle("active");
            this.classList.toggle("open");
        };
    });

    elementsTwo.forEach(function (element) {
        element.onclick = function () {
            this.parentElement
                .querySelector(".rn-megamenu")
                .classList.toggle("active");
            this.classList.toggle("open");
        };
    });

    React.useEffect(() => {
        document?.addEventListener('click', (e) => {
            if (e?.target?.classList?.contains('active')) {
                onClose()
            }
        })
    }, [])

    return (
        <>
            <div
                className={`popup-mobile-menu premium-mobile-menu ${show ? "active" : ""}`}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        onClose();
                    }
                }}
            >
                <div className="inner">
                    <div className="header-top premium-mobile-menu__top">
                        <Link
                            className="premium-mobile-menu__brand"
                            to="/"
                            onClick={onClose}
                            aria-label={t('footer.brandAlt')}
                        >
                            <img
                                className="logo-light"
                                src="https://images.happysolutions.hu/logo.png"
                                alt={t('footer.brandAlt')}
                            />
                            <span className="premium-mobile-menu__wordmark">
                                {t('common.appName')}
                            </span>
                        </Link>
                        <button
                            type="button"
                            className="premium-mobile-menu__close"
                            onClick={onClose}
                            aria-label={t('common.close', { defaultValue: 'Bezárás' })}
                        >
                            <i className="ri-close-line"></i>
                        </button>
                    </div>

                    <div className="premium-mobile-menu__body">
                        <Nav/>
                    </div>

                    <div className="premium-mobile-menu__footer">
                        <Link
                            to="/foglalas"
                            className="premium-mobile-menu__cta"
                            onClick={() => onClose()}
                        >
                            <i className="ri-sparkling-line" aria-hidden="true"></i>
                            {t('nav.support', { defaultValue: 'Kérjen ingyenes bemutatót!' })}
                        </Link>
                    </div>
                </div>
            </div>

            <div className={`edu-search-popup ${showSearch ? "open" : ""}`}>
                <div className="close-button">
                    <button className="close-trigger" onClick={onSearch}>
                        <i className="ri-close-line"></i>
                    </button>
                </div>
                <div className="inner">
                    <form className="search-form" action="#">
                        <input
                            type="text"
                            className="eduvibe-search-popup-field"
                            placeholder={t('common.searchPlaceholder')}
                        />
                        <button className="submit-button">
                            <i className="icon-search-line"></i>
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ResponsiveMenu;
